import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    // meta: {
    //   title: 'Protein Sublocalization Localization Database'
    // }
  },
  {
    path: '/job',
    name: 'job',
    component: () => import(/* webpackChunkName: "about" */ '@/views/JobView.vue'),
    meta: {
      title: 'Job Page | LocPro'
    }
  },
  {
    path: '/result',
    name: 'result',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ResultView.vue'),
    meta: {
      title: 'Result Page | LocPro'
    }
  },
  {
    path: '/result-all',
    name: 'result-all',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ResultViewAll.vue'),
    meta: {
      title: 'Result All | LocPro'
    }
  },
  {
    path: '/result-main',
    name: 'result-main',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ResultViewMain.vue'),
    meta: {
      title: 'Result Main | LocPro'
    }
  },

  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ContactView.vue'),
    meta: {
      title: 'Contact US | LocPro'
    }
  },

  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DownloadPage.vue'),
    meta: {
      title: 'Full Data Download | LocPro'
    }
  },




  {
    path: '/data/protein',
    name: 'data-protein',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DataProtein.vue'),
    meta: {
      title: 'Protein Information | LocPro'
    }
  },





  {
    path: '/manual',
    name: 'manual',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ManualPage.vue'),
    meta: {
      title: 'Manual | LocPro'
    }
  },

  {
    path: '/to-be-available',
    name: 'to-be-available',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ToBeAvailable.vue'),
    meta: {
      title: 'To be available | LocPro'
    }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
